function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBell = function SvgIconBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M14 5.496h-4c0-1.5.5-2.5 2-2.5s2 1 2 2.5zm-4 15.5h4c0 1.5-.5 2.5-2 2.5s-2-1-2-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M4.5 17.496v-7c0-1.713 1.068-3.099 2.5-4.035a9.107 9.107 0 0 1 4.9-1.465c1.715 0 3.67.53 5.1 1.465 1.432.936 2.5 2.322 2.5 4.035v7m-14.5 0c-1.38 0-2.5.62-2.5 2s1.12 2 2.5 2h14c1.38 0 2.5-.62 2.5-2s-1.12-2-2.5-2H5z"
  }));
};
export default SvgIconBell;